"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var findErrors_1 = require("lib/functions/findErrors");
var parts_1 = require("./parts");
var validations_1 = require("lib/functions/validations");
var helper_1 = require("lib/functions/helper");
var moment_1 = __importDefault(require("moment"));
var Popup_1 = require("components/Popup");
var interfaces_1 = require("data/interfaces");
var SignaturesCertificate_1 = require("../SignaturesCertificate");
var rules = {
    student: {
        email: validations_1.email,
        first_name: validations_1.mandatory,
        last_name: validations_1.mandatory,
        cell_phone: validations_1.mandatory,
        has18: validations_1.mandatory,
        student_signature_disclosure: validations_1.mandatory
    },
    others: {
        parent_signature_disclosure: validations_1.mandatory
    },
    staff: {}
};
var additionalStudentRules = {
    parent_name: validations_1.mandatory,
    parent_last_name: validations_1.mandatory,
    parent_email: validations_1.email
};
var getFormatDateNow = function () { return moment_1.default().format("MMMM Do YYYY"); };
var footer = {
    title: "",
    published: "Published: " + getFormatDateNow(),
    endPage: "2"
};
var Application = (function (_super) {
    __extends(Application, _super);
    function Application(props) {
        var _this = _super.call(this, props) || this;
        _this.errors = {};
        _this.onClickLogin = function () {
            _this.setState({ isVisible: true });
        };
        _this.onClickLogout = function () {
            _this.setState({ isVisible: false });
        };
        _this.onClose = function () {
            _this.setState({ isVisible: false });
        };
        _this.onChange = _this.onChange.bind(_this);
        _this.json_data = props.model.json_data;
        _this.onModel = _this.onModel.bind(_this);
        _this.isValid = _this.isValid.bind(_this);
        props.model.dispatcher.addListener(_this.onModel);
        _this.state = {
            isVisible: false
        };
        return _this;
    }
    Object.defineProperty(Application.prototype, "dataStore", {
        get: function () {
            return this.props.model.dataStore;
        },
        enumerable: true,
        configurable: true
    });
    Application.prototype.onModel = function () {
        this.json_data = this.props.model.json_data;
        this.forceUpdate();
    };
    Application.prototype.onChange = function (id, value) {
        console.log("Id", id);
        console.log("Value", value);
        this.json_data[id] = value;
        this.forceUpdate();
    };
    Application.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, success, errors, message;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.props.model.dispatcher.dispatch();
                        this.props.model.addValidateFunction("validateApplication", this.isValid);
                        if (!!this.props.model.urlQueryParams) return [3, 2];
                        return [4, this.props.model.getApiKeyBySlug()];
                    case 1:
                        _b.sent();
                        return [3, 4];
                    case 2: return [4, this.props.model.getTaskUserInformation()];
                    case 3:
                        _a = _b.sent(), success = _a.success, errors = _a.errors;
                        if (!success && errors) {
                            message = errors[0].message;
                            alert(message);
                        }
                        _b.label = 4;
                    case 4: return [2];
                }
            });
        });
    };
    Application.prototype.componentDidUpdate = function (prevProps) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (prevProps.model.user) {
                    this.props.model.addValidateFunction("validateApplication", this.isValid);
                }
                return [2];
            });
        });
    };
    Application.prototype.componentWillUnmount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.removeValidateFunction("validateApplication");
                this.props.model.dispatcher.removeListener(this.onModel);
                return [2];
            });
        });
    };
    Application.prototype.isValid = function () {
        console.log("Validate Application");
        var newRules = helper_1.getRulesByUserProfileType(rules, this.props.model.user.type);
        if (this.json_data.has18 &&
            this.json_data.has18 === "no" &&
            this.props.model.user.type === interfaces_1.UserProfileType.Student) {
            newRules = __assign(__assign({}, newRules), additionalStudentRules);
        }
        var _a = findErrors_1.findErrors(this.props.model.json_data, newRules), isValid = _a.isValid, errors = _a.errors;
        this.errors = errors;
        console.log("Form errors", mobx_1.toJS(this.errors));
        return isValid;
    };
    Application.prototype.render = function () {
        var model = this.props.model;
        var _a = this, errors = _a.errors, onChange = _a.onChange, onClickLogin = _a.onClickLogin, onClickLogout = _a.onClickLogout, onClose = _a.onClose;
        var isVisible = this.state.isVisible;
        return (react_1.default.createElement("div", null,
            isVisible && (react_1.default.createElement(Popup_1.Popup, { model: this.props.model, onChange: onChange, onClose: onClose })),
            react_1.default.createElement("div", { className: "gray-line" }),
            react_1.default.createElement(parts_1.Section1, { model: model, onChange: onChange, errors: errors, onClickLogin: onClickLogin, onClickLogout: onClickLogout, isVisible: isVisible }),
            window.isPdf && (react_1.default.createElement(SignaturesCertificate_1.SignatureCertificate, { model: model, title: "Signature certificate", subtitle: "Document Disclosure", signatureId: "signature" }))));
    };
    __decorate([
        mobx_1.observable
    ], Application.prototype, "errors", void 0);
    Application = __decorate([
        mobx_react_1.observer
    ], Application);
    return Application;
}(react_1.Component));
exports.Application = Application;
//# sourceMappingURL=data:application/json;base64,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